/* eslint-disable no-shadow */
/* eslint-disable no-console */
import './SpacerBlockLarge.css';
import type { BlockComponentProps } from 'client-react-block-renderer';
import React from 'react';

interface Props extends BlockComponentProps<BlockData, BlockConfig> {}

interface BlockConfig {}

interface BlockData {}

const SpacerBlockLarge = (props: Props) => {
  return <div className="rcm-spacer-large"></div>;
};
export default SpacerBlockLarge;
